import { forumError } from '../api/forumErrors';

/** Put state in component data; no event bus, store or request-per-watcher. */
export function createForumQueryController() {
  const state = { key: null, data: null, loading: false, refreshing: false, error: null };
  let revision = 0, disposed = false;
  function clear() {
    revision += 1;
    Object.assign(state, { key: null, data: null, loading: false, refreshing: false, error: null });
  }
  async function load(key, fetch) {
    if (disposed) return;
    const request = ++revision;
    if (key !== state.key) state.data = null;
    Object.assign(state, { key, loading: state.data === null, refreshing: state.data !== null, error: null });
    try {
      const value = await fetch();
      // Revision check is the atomicity guard; a late request cannot write state.
      // eslint-disable-next-line require-atomic-updates
      if (request === revision && !disposed) state.data = value;
      return request === revision && !disposed ? value : undefined;
    } catch (error) {
      if (request === revision && !disposed) {
        const failure = forumError(error);
        if (failure.code === 'stale_response') state.data = null;
        else {
          state.error = failure;
          // Revoked access must not leave the previously loaded private page visible.
          if ([401, 403, 404].includes(failure.status)) state.data = null;
        }
      }
      return undefined;
    } finally {
      if (request === revision && !disposed) Object.assign(state, { loading: false, refreshing: false });
    }
  }
  return { state, load, clear, dispose() { disposed = true; clear(); } };
}
